

export default {
  'zh-CN': {
    home: {
      Service:'服务全球',
      Commerce:'跨境电商',
      homeProvide:'为全球跨境电商提供高品质、全方位的服务解决方案',
      homeThrough:'致力于通过市场分析、系统研发及资源整合，为客户提供物流、金融、大数据等多方面的服务产品，为全球跨境电商提供高品质、全方位的服务解决方案。',
      Headlines:'活动与资讯',
      ViewAll:'查看全部',
      HeadlinesTitle01:'福州招商大会',
      HeadlinesContent01:'eBay福建跨境电商生态峰会暨厂商对接大会，在福州召开。聚焦科技，海纳资源，让跨境电商便捷、非凡。',
      HeadlinesTitle02:'SpeedPAK物流管理方案正式上线！',
      HeadlinescContent02:'SpeedPAK包裹服务是eBay联合物流战略合作伙伴橙联股份有限公司共同打造，以eBay平台物流政策为基础，为eBay大中华区跨境出口电商卖家量身定制的直发物流解决方案。',
      HeadlinesTitle03:'刚刚，eBay与中信产业基金正式签约，携手打造跨境电商物流体系！',
      HeadlinesContent03:'eBay与中信产业基金正式签约，携手打造跨境电商物流体系。众多重量级嘉宾参与并发表讲话。',
      //
      OurServices:'产品与服务',
      DirectMail:'海外直邮服务',
      getDetail:'获取详情',
      //
      ServiceSpec:'海外仓头程服务',
      Free:'国内上海、深圳两地集货，每周7天都可收货',
      Hours:'每周固定船期，海运拼箱+卡车派送',
      Mins:'物流轨迹可视追踪',
      //
      Other:'其他服务',
      Details:'其他服务详情介绍',
      //
      Finance:'金融服务',
      //  橙连介绍
      OrangeConnex:'橙联介绍',
      OrangeDetail01:'橙联股份是一家服务全球跨境电商的科技公司，致力于通过市场分析、系统研发及资源整合，为客户提供物流、金融、大数据等多方面的服务产品，为全球跨境电商提供高品质、全方位的服务解决方案。',
      OrangeDetail02:'橙联股份由国内私募股权投资领域的领先机构之一的中信产业基金和全球电子商务先锋eBay联合成立，拥有非常丰富的物流服务经验和客户市场资源，旨在为卖家客户提供快捷 、稳定 、成本领先 、可视及可持续的物流服务，让买家客户享有更加优质贴心的服务体验。',
    //  优势
      ShipmentTracking:'运单查询',
      TrackingNum:'输入运单号查询您的订单流转详情',
      PickUP:'全国揽收范围查询',
      Stations:'可查询全国范围所有的揽收网点地址及电话等详细信息',
      ProPrice:'价格/时效查询',
      DeliveryTime:'可查询订单运送的价格及预计到达时间，方便您准确把握信息',
      Package:'重量/尺寸/货值限制查询',
      Limitations:'可查询货物的重量、尺寸、货值的限制，省去您不必要的麻烦',
      Contrabands:'禁运产品查询',
      Countries:'可查询所到达国家的相关禁运规定物品，方便您寄送',
      //  关注我们 合作伙伴
      SocialMedias:'关注我们',
      Partners:'合作伙伴',
      bannerTitle1:'跨境直邮服务',
      bannerContent1:'创新、快速、可靠的国际包裹直邮科技平台',
      bannerTitle2:'海外仓配服务',
      bannerContent2:'全球技术支持的履行中心网络，为零售标准交付提供服务',
      bannerTitle3:'海外仓头程服务',
      bannerContent3:'一体化的全球长途货运网络（海运、空运、铁路）为您实现国际货物运输',
      bannerTitle4:'橙e供应链',
      bannerContent4:'全球采购科技平台，实现一站式采购解决方案服务',
      goToSite:'访问官网',
    }
  },
  'en-US':{
    home: {
      Service:'Service',
      Commerce:'to Global E-Commerce',
      homeProvide:'Provide Global E-Commerce Businesses with World-Class Service Quality, and Full-Circle Supply Chain Solutions.',
      homeThrough:'Through market analysis, system development, and resource integration, we provide services in logistic, finance, and big data aspects of global e-commerce industry.',
      Headlines:'Headlines',
      ViewAll:'View All',
      HeadlinesData01:'2018/03/13',
      HeadlinesTitle01:'Fuzhou Global E-commerce Summit',
      HeadlinesContent01:'ebay’s global e-commerce summit in Fuzhou has brought attentions from around the country. To ensure the future of global e-commerce to be more efficient…',
      HeadlinesData02:'2018/03',
      HeadlinesTitle02:'SpeedPAK is Officially Launched',
      HeadlinescContent02:'SpeedPAK service is brought to you by ebay and Orange Connex(China) Limited,. Developed on the foundation of ebay’s platform policy, then customized to provide direct mail service to e-commerce businesses in the great China region.',
      HeadlinesData03:'2018/03/06',
      HeadlinesTitle03:'Just Now! CITI CPE and ebay Kicked Off their New Era in Global E-commerce Industry.',
      HeadlinesContent03:'CITI CPE and ebay have launched their brand new masterpiece, a joint venture. Shocking the global market place with speeches from industry tycoons.',
      //
      OurServices:'Product and Service',
      DirectMail:'Direct Mail',
      getDetail:'Get details',
      //
      ServiceSpec:'Speed Freight',
      Free:'Shanghai & Shenzhen do original consolidation, cargo can be accepted 7x24',
      Hours:'Regular sailing date for LCL mode, truck transport for domestic delivery',
      Mins:'Tracking for end to end logistics',
      //
      Other:'Other Services',
      Details:'Coming soon…',
      //
      Finance:'Financial Product',
      //  橙连介绍
      OrangeConnex:'Orange Connex',
      OrangeDetail01:'Orange Connex(China) Limited is a technology company that is devoted to service global e-commerce industry. Through market analysis, system development, and resource integration, we provide services in logistic, finance, and big data aspects of global e-commerce industry.',
      OrangeDetail02:'Orange Connex(China) Limited is a joint venture between a leader in Chinese private equity investment, CITICPE, and the a pioneer of global e-commerce platform, eBay. Hence supporting our cause with tremendous amount of resources and years of successful experience within the industry. With our enriched background and strong foundation, our product is aimed to redefine our users’ experiences though Speed, Stability, Transparency, Cost Optimization, and Sustainability.',
    //  优势
      ShipmentTracking:'Shipment Tracking',
      TrackingNum:'Input your tracking number to track your packages',
      PickUP:'Pick-up Service Coverage',
      Stations:'Search for specific stations/areas including contact information',
      ProPrice:'Products and Pricing',
      DeliveryTime:'Search for specific product information such as pricing, and delivery time',
      Package:'Package Specifications',
      Limitations:'Search for package specifications such at limitations in size, weights, and value',
      Contrabands:'Contrabands',
      Countries:'Search for specific contrabands in our designated countries',
    //  关注我们 合作伙伴
      SocialMedias:'Social Medias',
      Partners:'Partners',
      bannerTitle1:'Direct Mail',
      bannerContent1:'Innovative, fast, and reliable international parcel direct shipping technology platform',
      bannerTitle2:'eBay fulfillment by Orange Connex',
      bannerContent2:'Global tech-enabled fulfillment center network to provide retail standard delivery',
      bannerTitle3:'Speed Freight',
      bannerContent3:'Integrated global linehaul freight network (sea, air, rail) that enables international freight delivery',
      bannerTitle4:'eSupplyChain',
      bannerContent4:'Global procurement technology platform that enables one stop procurement solution services',
      goToSite:'Go to Official Site',
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/Home_local.js